import React from 'react';
import { Img } from 'react-image';

type DevicePreviewMainProps = {
  imageSrc: string | null;
  title: string;
};

const DevicePreviewMain: React.FC<DevicePreviewMainProps> = ({ imageSrc, title }) => {
  return (
    <div className="raffle_image_section__preview_device">
      <div className="raffle_image_section__preview_notch" />
      <div className="raffle_image_section__preview_canvas raffle_image_section__preview_canvas--form">
        <div className="raffle_image_section__form_header">
          <span className="raffle_image_section__form_title_skeleton" />
        </div>
        <div className="raffle_image_section__form_image">
          {imageSrc ? (
            <Img src={imageSrc} alt={title} className="raffle_image_section__form_image_img" />
          ) : (
            <span className="raffle_image_section__form_image_empty" />
          )}
        </div>
        <div className="raffle_image_section__form_text">
          <span className="raffle_image_section__form_text_line raffle_image_section__form_text_line--lg" />
          <span className="raffle_image_section__form_text_line raffle_image_section__form_text_line--sm" />
        </div>
        <div className="raffle_image_section__form_fields">
          <span className="raffle_image_section__form_field" />
          <span className="raffle_image_section__form_field" />
          <span className="raffle_image_section__form_field" />
        </div>
        <div className="raffle_image_section__app_nav">
          <span className="raffle_image_section__app_nav_item" />
          <span className="raffle_image_section__app_nav_item" />
          <span className="raffle_image_section__app_nav_item" />
          <span className="raffle_image_section__app_nav_item" />
        </div>
      </div>
      <div className="raffle_image_section__preview_safe" />
    </div>
  );
};

export default DevicePreviewMain;
